/**
 * Script for Front Page
 *
 * @author Space-Time Inc.
 */

/**
 * Lists by Terms
 *
 * @author Space-Time Inc.
 */

(() => {
	const MAX_COUNT = 6;

	const root = document.querySelector('.part-dynamic-archive-filter');
	if (!root) return;
	const btns = root.querySelectorAll('button');

	const as = document.querySelectorAll('.part-dynamic-archive-filter-term-archive a');

	const items = document.querySelectorAll('.list-item-news > li');

	let current = 'all';

	for (const btn of btns) {
		btn.addEventListener('click', () => {
			current = btn.dataset.type;
			for (const b of btns) {
				if (btn === b) {
					b.classList.add('current');
				} else {
					b.classList.remove('current');
				}
			}
			for (const a of as) {
				if (a.dataset.type === current) {
					a.style.display = null;
				} else {
					a.style.display = 'none';
				}
			}
			set_item_visible(current, MAX_COUNT);
		});
	}

	function set_item_visible(f, count) {
		let i = 0;
		for (; i < items.length; i += 1) {
			const it = items[i];

			const v = ('all' === f) || (it.classList.contains(f));

			if (v) {
				it.style.display = '';
				count -= 1;
			} else {
				it.style.display = 'none';
			}
			if (count === 0) break;
		}
		i += 1;
		for (; i < items.length; i += 1) {
			items[i].style.display = 'none';
		}
	}

	btns[0].click();
	// list.classList.remove('first-view');
})();


